import React from 'react';
import { useTranslation } from 'react-i18next';
import SelectField from '@/components/common/SelectField';
import { UploadPreviewColumn } from '@/types/upload';

interface UploadColumnSelectProps {
  label: string;
  columns: UploadPreviewColumn[];
  /** Position of the column, or null when none is picked. */
  value: number | null;
  onChange: (position: number | null) => void;
  disabled?: boolean;
}

/** Picks one column of the sheet by its position, because headers can repeat. */
const UploadColumnSelect: React.FC<UploadColumnSelectProps> = ({ label, columns, value, onChange, disabled }) => {
  const { t } = useTranslation();
  return (
    <SelectField
      label={label}
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value === '' ? null : Number(e.target.value))}
      disabled={disabled}
    >
      <option value="">{t('uploads.pick_column')}</option>
      {columns.map((c) => (
        <option key={c.position} value={c.position}>
          {c.header || t('uploads.column_n', { n: c.position + 1 })}
        </option>
      ))}
    </SelectField>
  );
};

export default UploadColumnSelect;
